import { Avatar, Box, Button, Chip, Container, Stack, Typography } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { profile } from '../../data/profile';

export default function Hero() {
    return (
        <Box id="inicio" component="header" sx={{
            color: '#fff',
            background: 'radial-gradient(1200px 500px at 85% -10%, rgba(13,148,136,0.45), transparent 60%), #0b1220',
            py: { xs: 10, md: 16 },
        }}>
            <Container maxWidth="lg">
                <Stack direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 4, md: 8 }} alignItems={{ md: 'center' }}>
                    <Avatar src={profile.photo || undefined} alt={profile.name} sx={{
                        width: { xs: 96, md: 160 }, height: { xs: 96, md: 160 },
                        fontSize: { xs: 40, md: 64 }, fontWeight: 800,
                        bgcolor: 'primary.main', border: '4px solid rgba(255,255,255,0.12)',
                    }}>
                        {profile.name.charAt(0)}
                    </Avatar>
                    <Box>
                        <Chip icon={<PlaceOutlinedIcon />} label={profile.location}
                            sx={{ mb: 2, color: '#fff', bgcolor: 'rgba(255,255,255,0.08)', '& .MuiChip-icon': { color: 'primary.light' } }} />
                        <Typography variant="h1" sx={{ fontSize: { xs: '2.5rem', md: '3.75rem' } }}>
                            Hola, soy {profile.name}
                        </Typography>
                        <Typography variant="h5" sx={{ color: 'primary.light', fontWeight: 600, mt: 1 }}>
                            {profile.role}
                        </Typography>
                        <Typography sx={{ color: 'rgba(255,255,255,0.75)', mt: 2, maxWidth: 620, fontSize: '1.1rem', lineHeight: 1.7 }}>
                            {profile.tagline}
                        </Typography>
                        <Stack direction="row" spacing={1.5} sx={{ mt: 4, flexWrap: 'wrap', rowGap: 1.5 }}>
                            <Button variant="contained" size="large" href="#contacto" startIcon={<MailOutlineIcon />}>
                                Contáctame
                            </Button>
                            <Button variant="outlined" size="large" href={profile.github} target="_blank" rel="noopener"
                                startIcon={<GitHubIcon />} sx={{ color: '#fff', borderColor: 'rgba(255,255,255,0.3)' }}>
                                GitHub
                            </Button>
                            {profile.linkedin && (
                                <Button variant="outlined" size="large" href={profile.linkedin} target="_blank" rel="noopener"
                                    startIcon={<LinkedInIcon />} sx={{ color: '#fff', borderColor: 'rgba(255,255,255,0.3)' }}>
                                    LinkedIn
                                </Button>
                            )}
                            {profile.cv && (
                                <Button variant="text" size="large" href={profile.cv} target="_blank" rel="noopener" sx={{ color: 'primary.light' }}>
                                    Descargar CV
                                </Button>
                            )}
                        </Stack>
                    </Box>
                </Stack>
            </Container>
        </Box>
    );
}
